import templateReviewService from './templateReviewService'

export default templateReviewService
